import { Denomination } from "../Denomination";

export class TransactionCashAdditionalData {
    public id: number;
    public transactionNop: string;
    public machineInstallationName: string;
    public machineSerialNumber: string;
    public denomination: Denomination;
    public ecbClass: number;
    public destination: string;
    public serialNumber1: string;
    public serialNumber2: string;
    public receivedAt: Date;


    static Parse(data: any): TransactionCashAdditionalData {
        var res = new TransactionCashAdditionalData ();
        res.id = data.Id;
        res.transactionNop = data.TransactionNop;
        res.machineInstallationName = data.MachineInstallationName;
        res.machineSerialNumber = data.MachineSerialNumber;
        res.denomination = new Denomination();
        res.denomination.parse(data.Denomination);
        res.ecbClass = data.EcbClass;
        res.destination = data.Destination;
        res.serialNumber1 = data.SerialNumber1;
        res.serialNumber2 = data.SerialNumber2;
        res.receivedAt = new Date(data.ReceivedAt);
        return res;
    }
}